/** @type {Styles} */
export const styles = {
  base: {
    lineHeight: 1.33,
    display: 'inline-block',
  },
  flex: {
    display: 'flex',
  },
}
